<template>
    <div class="wrap voice-trigger-wrap">
        <button type="button"
                class="voice-trigger"
                :class="{recording: recording, loading: loading}"
                :disabled="loading"
                @click.prevent="$emit('toggle')">

            <span class="voice-trigger-badge">IA</span>

            <span class="voice-trigger-icon">
                <span class="voice-trigger-pulse" v-if="recording"></span>
                <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M12 15a3 3 0 0 0 3-3V6a3 3 0 0 0-6 0v6a3 3 0 0 0 3 3Z" fill="currentColor"/>
                    <path d="M19 11a1 1 0 0 0-2 0 5 5 0 0 1-10 0 1 1 0 0 0-2 0 7 7 0 0 0 6 6.92V20H9a1 1 0 0 0 0 2h6a1 1 0 0 0 0-2h-2v-2.08A7 7 0 0 0 19 11Z" fill="currentColor"/>
                </svg>
            </span>

            <span class="voice-trigger-label">
                <strong>
                    {{ loading ? 'Analyse en cours…' : (recording ? 'Enregistrement en cours…' : "Dicter les infos de l'intervention") }}
                </strong>
                <small v-if="loading">Cela peut prendre jusqu'à une minute</small>
                <small v-else-if="recording">Touchez pour arrêter</small>
                <small v-else>Fonctionnalité pilote</small>
            </span>

        </button>
    </div>
</template>

<script>

    export default {

        props: {
            recording: {type: Boolean, default: false},
            loading: {type: Boolean, default: false},
        },

    }

</script>

<style>

    button.voice-trigger {
        position: relative;
        display: flex;
        align-items: center;
        width: 100%;
        margin-bottom: 20px;
        padding: 12px 18px;
        border: none;
        border-radius: 10px;
        background: linear-gradient(135deg, #5698d2, #3d6f9e);
        box-shadow: 0 2px 6px rgba(43, 76, 105, 0.35);
        text-align: left;
        cursor: pointer;
        transition: background 0.2s ease, box-shadow 0.2s ease;
    }

    button.voice-trigger:active {
        box-shadow: 0 1px 3px rgba(43, 76, 105, 0.35);
    }

    button.voice-trigger.recording {
        background: linear-gradient(135deg, #d33a3a, #a11616);
        box-shadow: 0 2px 10px rgba(163, 22, 22, 0.45);
    }

    button.voice-trigger.loading {
        opacity: 0.85;
        cursor: wait;
    }

    button.voice-trigger .voice-trigger-badge {
        position: absolute;
        top: -8px;
        right: -6px;
        background-color: #ffb100;
        color: #402d00;
        font-size: 1rem;
        font-weight: 700;
        letter-spacing: 0.05rem;
        padding: 2px 7px;
        border-radius: 20px;
        box-shadow: 0 1px 3px rgba(0, 0, 0, 0.3);
    }

    button.voice-trigger .voice-trigger-icon {
        position: relative;
        display: flex;
        align-items: center;
        justify-content: center;
        flex-shrink: 0;
        width: 42px;
        height: 42px;
        margin-right: 14px;
        border-radius: 50%;
        background-color: rgba(255, 255, 255, 0.18);
        color: #fff;
    }

    button.voice-trigger .voice-trigger-icon svg {
        position: relative;
        z-index: 1;
        width: 22px;
        height: 22px;
    }

    button.voice-trigger .voice-trigger-pulse {
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        border-radius: 50%;
        background-color: rgba(255, 255, 255, 0.55);
        animation: voice-pulse 1.4s ease-out infinite;
    }

    @keyframes voice-pulse {
        0% {
            transform: scale(1);
            opacity: 0.6;
        }
        100% {
            transform: scale(1.9);
            opacity: 0;
        }
    }

    button.voice-trigger .voice-trigger-label {
        display: flex;
        flex-direction: column;
        color: #fff;
        text-align: left;
    }

    button.voice-trigger .voice-trigger-label strong {
        font-size: 1.4rem;
        text-transform: none;
        line-height: 1.3;
    }

    button.voice-trigger .voice-trigger-label small {
        font-size: 1.1rem;
        color: rgba(255, 255, 255, 0.85);
        text-transform: none;
        margin-top: 2px;
    }

</style>



// WEBPACK FOOTER //
// VoiceTriggerButton.vue?1b111b4e